import React, { useState } from "react";
import downArrow from "../assets/downArrow.png"; // Replace with the actual path to your image

const QuestionSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const questions = [
    {
      question: "How can I trust this website?",
      answer:
        "We’ve been operating for over 4 years and have served thousands of customers. You can also check our reviews on Trustpilot for added assurance.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept most major debit/credit cards, Apple Pay, and Google Pay.",
    },
    {
      question: "Can I track my order status?",
      answer:
        "Yes! Once you place an order, you can track its progress in the 'My Orders' section.",
    },
    {
      question: "Is my account safe from bans?",
      answer:
        "Yes, we use the safe 'snipe method' to transfer coins, unlike the riskier comfort trade used by other sellers. This keeps your account secure. Additionally, you can keep the coins in your account and spend them whenever you want.",
    },
    {
      question: "Can I play the game while my order is being processed?",
      answer:
        "No, please stay off your account until you receive the 'Order Delivered' email. Using the account during processing can cause delays.",
    },
    {
      question: "What if there’s a problem with my order?",
      answer:
        "If you face any issues, contact us via live chat or reach out to us on Discord, and we’ll resolve it promptly.",
    },
    {
      question: "How do I know if I’m eligible to buy coins?",
      answer:
        "Check if you have access to the transfer market in the Web App or Companion App. If you do, you’re eligible to buy coins.",
    },
    {
      question: "How do I prepare my account?",
      answer:
        "You must have at least 1,500 coins in your account and have the Transfer Market unlocked on the Web App before placing an order. You cannot be unassigned either.",
    },
    {
      question: "Can I play while you are processing my order?",
      answer:
        "No, please stay off the account until you receive an Order Delivered email from us. If you’re on the account while we try to deliver the order, it will probably be delayed.",
    },
    {
      question: "What are the chances of a ban?",
      answer:
        "We’ve serviced thousands of customers and have never run into any issues with bans.",
    },
  ];



  return (
    <>
      {/* Header Section */}
      <section id="faq">
        <div className="lg:bg-black bg-[#191919]  flex flex-col items-center space-y-6">
          {/* Title */}
          <h1
            className="text-3xl md:text-6xl lg:text-6xl font-monument font-extrabold text-primary text-center"
            style={{ fontFamily: "", fontWeight: 800 }}
          >
            ANY QUESTIONS?
          </h1>


          {/* Down Arrow */}
          <img src={downArrow} alt="Arrow Down" className="h-6 md:h-8" />
        </div>

        {/* FAQ Section */}
        <div className="lg:bg-black text-left bg-[#191919] text-primary text-sm font-inter py-10 px-12 lg:px-20">
          <div className="max-w-4xl mx-auto">
            {questions.map((item, index) => (
              <div
                key={index}
                className={`mb-4 p-4 font-inter font-medium  text-sm rounded-2xl ${activeIndex === index ? "bg-[#2a2922]" : "bg-[#202018]"
                  }`}
              >
                {/* Question Header */}
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleQuestion(index)}
                >
                  <h2 className="font-inter text-[18px]  text-sm  font-medium">
                    {item.question}
                  </h2>
                  <span className="text-sm ">
                    {activeIndex === index ? "−" : "+"}
                  </span>
                </div>

                {/* Answer Section */}
                {activeIndex === index && (
                  <p className="mt-6 text-sm text-white">
                    {item.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>


    </>
  );
};

export default QuestionSection;
